import { EarningsState } from './state';
import { earningsInitialState } from './initial-state';
import { EarningsActions } from './action-creators';
import * as actions from './actions';
import Dinero from 'dinero.js';
import { EarningsAssignment } from '@services/earnings/types/earnings-assignment';

export const earningsReducer = (
  state: EarningsState = earningsInitialState,
  action: EarningsActions
): EarningsState => {
  switch (action.type) {
    case actions.LIST_EARNINGS_SUCCESS: {
      const pendingEntries: EarningsAssignment[] = action.earnings.reduce(
        (memo: EarningsAssignment[], report) => {
          return memo.concat(
            report.entries.filter(
              (entry) => Number(entry.eligibleDate) > Number(new Date())
            )
          );
        },
        []
      );

      const eligibleEntries: EarningsAssignment[] = action.earnings.reduce(
        (memo: EarningsAssignment[], report) => {
          return memo.concat(
            report.entries.filter(
              (entry) => Number(entry.eligibleDate) <= Number(new Date())
            )
          );
        },
        []
      );

      return {
        ...state,
        data: {
          ...state.data,
          [action.key]: action.earnings,
        },
        pendingEntries: {
          ...state.pendingEntries,
          [action.key]: pendingEntries,
        },
        eligibleEntries: {
          ...state.eligibleEntries,
          [action.key]: eligibleEntries,
        },
        pending: {
          ...state.pending,
          [action.key]: action.earnings.reduce(
            (memo, report) => memo.add(report.pending),
            Dinero({ amount: 0, currency: 'USD', precision: 5 })
          ),
        },
        available: {
          ...state.available,
          [action.key]: action.earnings.reduce(
            (memo, report) => memo.add(report.available),
            Dinero({ amount: 0, currency: 'USD', precision: 5 })
          ),
        },
        streams: {
          ...state.streams,
          [action.key]: action.earnings.reduce(
            (memo, report) => memo + report.streams,
            0
          ),
        },
        downloads: {
          ...state.downloads,
          [action.key]: action.earnings.reduce(
            (memo, report) => memo + report.downloads,
            0
          ),
        },
        upcs: {
          ...state.upcs,
          [action.key]: action.earnings.reduce(
            (memo, report) => memo + report.upcs,
            0
          ),
        },
        pendingStart: {
          ...state.pendingStart,
          [action.key]: new Date(
            Math.min(
              ...eligibleEntries.map((e) =>
                Number(new Date(`${e.streamsDate}-15`))
              )
            )
          ),
        },
        pendingEnd: {
          ...state.pendingEnd,
          [action.key]: new Date(
            Math.max(
              ...eligibleEntries.map((e) =>
                Number(new Date(`${e.streamsDate}-15`))
              )
            )
          ),
        },
      };
    }

    case actions.GET_TOTAL_EARNINGS_SUCCESS: {
      return {
        ...state,
        total: {
          ...state.total,
          [action.ownerId]: action.total,
        },
      };
    }

    case actions.GET_EARNINGS_EXPORT_URL: {
      return {
        ...state,
        exportStatus: 'processing',
      };
    }

    case actions.GET_EARNINGS_EXPORT_URL_SUCCESS: {
      return {
        ...state,
        exportUrl: action.url,
        exportStatus: 'success',
      };
    }

    case actions.GET_EARNINGS_EXPORT_URL_ERROR: {
      return {
        ...state,
        exportStatus: 'error',
      };
    }

    case actions.LIST_DEACTIVATED_ARTIST_EARNINGS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          [action.artistId]: action.earnings,
        },
      };
    }

    default: {
      return { ...state };
    }
  }
};
